import { render, staticRenderFns } from "./CommonDateButton.vue?vue&type=template&id=5978f6df&scoped=true"
import script from "./CommonDateButton.vue?vue&type=script&lang=js"
export * from "./CommonDateButton.vue?vue&type=script&lang=js"
import style0 from "./CommonDateButton.vue?vue&type=style&index=0&id=5978f6df&prod&lang=less&scoped=true"
import style1 from "./CommonDateButton.vue?vue&type=style&index=1&id=5978f6df&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5978f6df",
  null
  
)

export default component.exports